import { Box, Divider, List, Paper, Typography } from "@mui/material";
import { useAppSelector } from "shared/lib/hooks/hooks";
import { MarathonListItem } from "../ListItem/ListItem";
import { useTranslation } from "react-i18next";

const ProductInfo = () => {
  const { t } = useTranslation();
  const { data } = useAppSelector((state) => state.products.userMarathonProducts.response);
  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
      }}
    >
      <Box display="flex" columnGap={2} pb={2}>
        <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
          {t("registerToMarathon.orders")}
        </Typography>
        <Divider
          sx={{
            flexGrow: 1,
            height: "1px",
            my: "auto",
            backgroundColor: "#ECF2F7",
          }}
        />
      </Box>
      {data?.map((p) => (
        <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <MarathonListItem
            label={`${p.name}, ${p.description}`}
            value={`${p.quantity} ${t("registerToMarathon.pieces")}`}
          />
        </List>
      ))}
    </Paper>
  );
};

export default ProductInfo;